import { render, staticRenderFns } from "./project-label-edit.vue?vue&type=template&id=33fdfb47&"
import script from "./project-label-edit.vue?vue&type=script&lang=js&"
export * from "./project-label-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports